import React from "react";
import { TimePicker } from "@fluentui/react";
import { DatePicker } from "./DatePicker";

const DateTimePicker = ({ name, label, datetime, setDateTime, required = false }) => {
    return (
        <div className="displayflex">
            <DatePicker
                name={name}
                label={label}
                style={{ flex: 1 }}
                value={datetime}
                onSelectDate={(date) => {
                    if (date) {
                        const updated = new Date(date);
                        if (datetime instanceof Date) {
                            updated.setHours(datetime.getHours());
                            updated.setMinutes(datetime.getMinutes());
                        }
                        setDateTime(updated);
                    }
                }}
                allowTextInput
                isRequired={required}
            />
            <TimePicker
                style={{ width: 80, marginTop: 29, marginLeft: 5 }}
                value={datetime ?? new Date()}
                onChange={(_, time) => {
                    if (time) {
                        const updated = datetime instanceof Date ? new Date(datetime) : new Date();
                        updated.setHours(time.getHours());
                        updated.setMinutes(time.getMinutes());
                        setDateTime(updated);
                    }
                }}
                allowFreeform
            />
        </div>
    );
};

export default DateTimePicker;
